// Make constructor globally available
window.MeetAjaxForProduct = function ajaxConstructor(settings) {
  var default_Data = {
    container: "#infinteLoop",
    method: "scroll",
    callback: null,
    loadingText: "Loading Now....",
    pagination: "#infinitePagination",
    offset: 0,
  };

  var data = settings || {};
  this.data = Object.assign(default_Data, data);

  this.meetProductClick = this.meetProductClick.bind(this);
  this.meetProductScroll = this.meetProductScroll.bind(this);
  this.meetProductDestroy = this.meetProductDestroy.bind(this);
  this.meetStopProductMultipleClicks = this.meetStopProductMultipleClicks.bind(this);
  this.meetProductPaginationlnView = this.meetProductPaginationlnView.bind(this);
  this.startPrefetch = this.startPrefetch.bind(this);

  this.meetProductpagination = document.querySelector(this.data.pagination);
  this.meetProductcontainer = document.querySelector(this.data.container);

  this.prefetchedData = null;
  this.prefetchPromise = null;
  this.prefetchObserver = null;

  this.meetProductInitialize();
};

// Use window.MeetAjaxForProduct.prototype everywhere
window.MeetAjaxForProduct.prototype.meetProductInitialize = function() {
  if (!this.meetProductcontainer) return;

  // Re-query pagination element in case DOM was updated
  this.meetProductpagination = document.querySelector(this.data.pagination);
  if (!this.meetProductpagination) return;

  this.nextPageLinkElement = this.meetProductpagination.querySelector("a");
  if (this.nextPageLinkElement) {
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.setupPrefetchObserver();
  }

  var initialidata = {
    click: this.meetProductClick,
    scroll: this.meetProductScroll,
  };
  if (initialidata[this.data.method]) {
    initialidata[this.data.method]();
  }
};

// Smart background prefetch observer
window.MeetAjaxForProduct.prototype.setupPrefetchObserver = function() {
  if (!this.nextPageUrl || !('IntersectionObserver' in window)) return;

  if (this.prefetchObserver) {
    this.prefetchObserver.disconnect();
  }

  this.prefetchObserver = new IntersectionObserver(function(entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        this.startPrefetch();
        if (this.prefetchObserver) {
          this.prefetchObserver.disconnect();
        }
        break;
      }
    }
  }.bind(this), {
    rootMargin: "800px 0px 800px 0px"
  });

  if (this.meetProductpagination) {
    this.prefetchObserver.observe(this.meetProductpagination);
  }
};

window.MeetAjaxForProduct.prototype.startPrefetch = function() {
  if (!this.nextPageUrl || this.prefetchPromise) return;

  var targetUrl = this.nextPageUrl;
  this.prefetchPromise = fetch(targetUrl, { credentials: 'same-origin' })
    .then(function(res) {
      if (!res.ok) throw new Error("Network response was not ok");
      return res.text();
    })
    .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      var cratedPagination = doc.querySelector(this.data.pagination);
      var cratedContainer = doc.querySelector(this.data.container);

      this.prefetchedData = {
        url: targetUrl,
        doc: doc,
        paginationHtml: cratedPagination ? cratedPagination.innerHTML : "",
        containerHtml: cratedContainer ? cratedContainer.innerHTML : "",
        hasMore: Boolean(doc.querySelector(this.data.pagination + " a"))
      };

      // Pre-cache all upcoming product card images into browser HTTP cache
      if (cratedContainer) {
        var imgElements = cratedContainer.querySelectorAll('img');
        imgElements.forEach(function(img) {
          var srcToPreload = img.getAttribute('src');
          if (!srcToPreload || srcToPreload.startsWith('data:')) {
            srcToPreload = img.dataset.src || (img.srcset && img.srcset.split(',')[0].trim().split(' ')[0]) || (img.dataset.srcset && img.dataset.srcset.split(',')[0].trim().split(' ')[0]);
          }
          if (srcToPreload && !srcToPreload.startsWith('data:')) {
            var preloader = new Image();
            preloader.src = srcToPreload;
          }
        });
      }

      return this.prefetchedData;
    }.bind(this))
    .catch(function(err) {
      console.warn("Smart prefetch skipped, falling back to direct fetch:", err);
      this.prefetchedData = null;
      this.prefetchPromise = null;
    }.bind(this));
};

window.MeetAjaxForProduct.prototype.meetProductScroll = function() {
  if (this.meetProductpagination) {
    document.addEventListener("scroll", this.meetProductPaginationlnView);
    window.addEventListener("resize", this.meetProductPaginationlnView);
    window.addEventListener("orientationchange", this.meetProductPaginationlnView);
  }
};

window.MeetAjaxForProduct.prototype.meetProductClick = function() {
  if (this.meetProductpagination) {
    this.nextPageLinkElement = this.meetProductpagination.querySelector("a");
    this.clickActive = true;
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.addEventListener("click", this.meetStopProductMultipleClicks);
    }
  }
};

window.MeetAjaxForProduct.prototype.meetStopProductMultipleClicks = function(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.data.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

window.MeetAjaxForProduct.prototype.meetProductPaginationlnView = function() {
  if (!this.meetProductpagination) return;
  var top = this.meetProductpagination.getBoundingClientRect().top - this.data.offset;
  var bottom = this.meetProductpagination.getBoundingClientRect().bottom + this.data.offset;

  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.meetProductpagination.querySelector("a");
    this.removeScrollListener();

    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = this.data.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

// Apply lazy loading to newly appended images after AJAX load
window.MeetAjaxForProduct.prototype.lazyLoadNewImages = function(container) {
  var target = container || this.meetProductcontainer;
  if (!target) return;

  // Immediate paint for pre-cached product images
  target.querySelectorAll('img[loading="lazy"]:not(.is-eager)').forEach(function(img) {
    img.loading = 'eager';
    img.classList.add('is-eager');
  });

  target.querySelectorAll('img[data-src]:not(.is-loaded)').forEach(function(img) {
    var dataSrc = img.dataset.src;
    var dataSrcset = img.dataset.srcset;

    if (dataSrc && img.getAttribute('src') !== dataSrc) {
      img.src = dataSrc;
    }

    if (dataSrcset && img.getAttribute('srcset') !== dataSrcset) {
      img.srcset = dataSrcset;
    }

    img.classList.add('is-loaded');
  });
};

window.MeetAjaxForProduct.prototype.renderLoadedData = function(data) {
  var loaderElement = document.getElementById("loader");

  if (data && data.containerHtml) {
    if (this.meetProductpagination) {
      this.meetProductpagination.innerHTML = data.paginationHtml;
    }

    if (this.meetProductcontainer) {
      this.meetProductcontainer.insertAdjacentHTML("beforeend", data.containerHtml);
      this.lazyLoadNewImages(this.meetProductcontainer);
    }

    if (this.data.callback && typeof this.data.callback === "function") {
      this.data.callback(data.doc);
    }

    if (!data.hasMore) {
      this.removeScrollListener();
      if (this.prefetchObserver) this.prefetchObserver.disconnect();
      if (loaderElement) loaderElement.style.display = "none";
    } else {
      // Reset prefetch state and setup observer for next page
      this.prefetchedData = null;
      this.prefetchPromise = null;
      this.meetProductInitialize();
    }
  } else {
    if (loaderElement) loaderElement.style.display = "none";
  }
};

window.MeetAjaxForProduct.prototype.loadMore = function() {
  var loaderElement = document.getElementById("loader");
  if (loaderElement) loaderElement.style.display = "block";

  // If already prefetched and URL matches, render immediately (0ms wait!)
  if (this.prefetchedData && this.prefetchedData.url === this.nextPageUrl) {
    this.renderLoadedData(this.prefetchedData);
    return;
  }

  // If prefetch is currently in-flight, wait for it without duplicating requests
  if (this.prefetchPromise) {
    this.prefetchPromise.then(function(data) {
      if (data && data.url === this.nextPageUrl) {
        this.renderLoadedData(data);
      } else {
        this.fetchDirectly();
      }
    }.bind(this));
    return;
  }

  // Fallback: Immediate fetch with NO 2000ms delay
  this.fetchDirectly();
};

window.MeetAjaxForProduct.prototype.fetchDirectly = function() {
  if (!this.nextPageUrl) return;
  var targetUrl = this.nextPageUrl;

  fetch(targetUrl, { credentials: 'same-origin' })
    .then(function(res) {
      if (!res.ok) throw new Error("Network response was not ok");
      return res.text();
    })
    .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      var cratedPagination = doc.querySelector(this.data.pagination);
      var cratedContainer = doc.querySelector(this.data.container);

      var data = {
        url: targetUrl,
        doc: doc,
        paginationHtml: cratedPagination ? cratedPagination.innerHTML : "",
        containerHtml: cratedContainer ? cratedContainer.innerHTML : "",
        hasMore: Boolean(doc.querySelector(this.data.pagination + " a"))
      };
      this.renderLoadedData(data);
    }.bind(this))
    .catch(function(err) {
      console.error("Failed to load products:", err);
      var loaderElement = document.getElementById("loader");
      if (loaderElement) loaderElement.style.display = "none";
    }.bind(this));
};

window.MeetAjaxForProduct.prototype.removeScrollListener = function() {
  document.removeEventListener("scroll", this.meetProductPaginationlnView);
  window.removeEventListener("resize", this.meetProductPaginationlnView);
  window.removeEventListener("orientationchange", this.meetProductPaginationlnView);
};

window.MeetAjaxForProduct.prototype.meetProductDestroy = function() {
  if (this.prefetchObserver) {
    this.prefetchObserver.disconnect();
  }
  this.prefetchedData = null;
  this.prefetchPromise = null;

  var yereData = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener,
  };
  if (yereData[this.data.method]) {
    yereData[this.data.method]();
  }
  return this;
};

window.MeetAjaxForProduct.prototype.removeClickListener = function() {
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener("click", this.meetStopProductMultipleClicks);
  }
};
